import { render, staticRenderFns } from "./AllKey.vue?vue&type=template&id=021d4b33&scoped=true"
import script from "./AllKey.vue?vue&type=script&lang=js"
export * from "./AllKey.vue?vue&type=script&lang=js"
import style0 from "./AllKey.vue?vue&type=style&index=0&id=021d4b33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021d4b33",
  null
  
)

/* custom blocks */
import block0 from "./AllKey.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports